import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import type { FC } from 'react';
import { NavLink } from '../nav-link/nav-link.js';

export interface MenuItemProps {
  icon: JSX.Element;
  label: string;
  route: string;
}

export const MenuItem: FC<MenuItemProps> = ({ icon, label, route }) => (
  <ListItem disablePadding>
    <ListItemButton component={NavLink} to={route}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </ListItemButton>
  </ListItem>
);
